var Dimensions = {
  get width() {
    return typeof window !== 'undefined' ? window.innerWidth : Infinity;
  },
  get height() {
    return typeof window !== 'undefined' ? window.innerHeight : Infinity;
  }
};
export { Dimensions };
//# sourceMappingURL=index.js.map